let curl = ''
let curs = ''
let curls = ''
let bank = ''
let asset = ''
if (location.host == '202.130.113.149') { //正式
  bank = 'http://202.130.113.149:2352/'; //測試
	curl = 'http://202.130.113.149:2352/'; //正式
	curls = 'http://202.130.113.149:3785/'; //正式
  curs = 'http://202.130.113.149:3789/'
  asset = 'http://202.130.113.149:2356/'
}

else { //測試 localhost
  bank = 'http://192.168.31.234:2352/'; //本地
  curl = 'http://192.168.31.234:2352/'; //本地
	curls = 'http://192.168.31.234:3785/'; //本地
  curs = 'http://192.168.31.234:3789/'
  asset = 'http://192.168.31.234:2356/'

	// bank = 'http://202.130.113.149:2352/'; //測試
	// curl = 'http://202.130.113.149:2352/'; //測試
	// curls = 'http://202.130.113.149:3785/'; //測試
  // curs = 'http://202.130.113.149:3789/'
  // asset = 'http://202.130.113.149:2356/'


}
if(location.hostname == 'hk.qmisit.com'||location.hostname == 'www.qmisgroup.com'||
location.hostname == 'qmisgroup.com' || location.hostname == 'hk.iqmis.com'|| location.hostname == 'qmisib.com.my'){
  // bank = 'https://hk.qmisit.com:2346/'; //正式
  // curl = 'https://hk.qmisit.com:2346/'; //正式 https://hk.qmisit.com:2346
  bank = 'https://qmisib.com.my:2352/'; //正式
  curl = 'https://qmisib.com.my:2352/'; //正式 https://hk.qmisit.com:2346
  curls = 'https://hk.qmisit.com:3785/'; //正式 https://hk.qmisit.com:2346
  curs = 'https://hk.qmisit.com:3789/'
}
if(sessionStorage['onlinestate'] == 'pc'){
  curl += 'groupweb/'
}else{
  curl += 'groupwebapp/'
}
curs += 'qmisweb/'

module.exports = {
  getGroupRevelation:curl + 'getGroupRevelation',
  getResponsibleOfficerTypePage:curl+'getResponsibleOfficerTypePage',
  //免責聲明
  getGroupDisclaimer:curl + 'getGroupDisclaimer',
  //德股服務收費
  getDEServiceCostList:curl+'getDEServiceCostList',
  //德股交易方式
  getDETradingWay:curl+'getDETradingWay',
  //德股市場介紹
  getDEMarketInfo:curl+'getDEMarketInfo',
  getResponsibleOfficerType149Page:curl+'getResponsibleOfficerType149Page',
  getResponsibleOfficerType1Page:curl + 'getResponsibleOfficerType1Page',
  getAlldownloads:curl + 'getAlldownloads',
  tocurl:curl,
  //搜索.
  getUrlWithSearchStr:curl+'getUrlWithSearchStr',
  getcurlWithSearchStr:curl+'getcurlWithSearchStr',
  //資產管理
  getIntroductionPage:curl +'getIntroductionPage',
  getHKMarketInfo: curl + 'getHKMarketInfo',
  getUSMarketInfo:curl + 'getUSMarketInfo',
  getWelcomeToJoin:curl + 'getWelcomeToJoin',
  getHkTradingWay:curl + 'getHkTradingWay',
  getHkServiceCost:curl + 'getHkServiceCost',
  getGroupMenu:curl + 'getGroupMenu',
  getUSTradingWay:curl + 'getUSTradingWay',
  getSHKMarketInfo:curl + 'getSHKMarketInfo',
  getSHKTradingWay:curl + 'getSHKTradingWay',
  getSGMarketInfo:curl + 'getSGMarketInfo',
  getSGTradingWay:curl + 'getSGTradingWay',
  getTPMarketInfo:curl + 'getJPMarketInfo',
  getJPTradingWay:curl + 'getJPTradingWay',
  getTWMarketInfo:curl + 'getTWMarketInfo',
  getTWTradingWay:curl + 'getTWTradingWay',
  getAUMarketInfo:curl + 'getAUMarketInfo',
  getMYSMarketInfo:curl + 'getMYSMarketInfo',
  getMYSTradingWay:curl + 'getMYSTradingWay',
  getAUTradingWay:curl  +'getAUTradingWay',
  getHKServiceCostList:curl + 'getHKServiceCostList',
  getUSServiceCostList:curl + 'getUSServiceCostList',
  getSHKServiceCostList:curl + 'getSHKServiceCostList',
  getSGServiceCostList:curl + 'getSGServiceCostList',
  getJPServiceCostList:curl + 'getJPServiceCostList',//日
  getMYSServiceCostList:curl + 'getMYSServiceCostList',
  getAUServiceCostList:curl + 'getAUServiceCostList',
  getTWServiceCostList:curl + 'getTWServiceCostList',
  getAllCostList:curl + 'getAllCostList',
  getStockTransferInfo:curl + 'getStockTransferInfo',
  getBondService:curl + 'getBondService',
  getFundService:curl + 'getFundService',
  getIpoPageInfo:curl + 'getIpoPageInfo',
  AccopenInperson:curl + 'getAccopenInperson',
  AccopenByPost:curl + 'getAccopenByPost',
  AccopenByAppointment:curl + 'getAccopenByAppointment',
  AccopenOnline:curl + 'getAccopenOnline',
  DataService:curl + 'getDataService',
  TableDownload:curl + 'getTableDownload',
  GroupFAQ:curl + 'getGroupFAQ',
  FAQPage:curl + 'getFAQPage',
  HolidaysPage:curl + 'getHolidaysPage',
  FDAWPage:curl + 'getFDAWPage',
  AboutUsPage:curl + 'getAboutUsPage',
  getNoticePage:curl + 'getNoticePage',
  getNoticeWithid:curl + 'getNoticeWithid',
  getFirstPage:curl + 'getFirstPage',
  getContactUsPage:curl + 'getContactUsPage',
  getManagement:curl + 'getManagementServicesPage',
  getInvestment:curl + 'getInvestmentStrategyPage',
  getCFPPage:curl + 'getCFPPage',
  discretionary:curl + 'getDiscretionaryPage',
  advicePage:curl + 'getSafenoticeAdvicePage',
  getTermsAnd:curl + 'getTermsAndConditionsPage',
  getHyperlink:curl + 'getHyperlinkPolicyPage',
  getSecuritiesPage:curl + 'getSecuritiesPage',
  getJoinUsPage:curl + 'getJoinUsPage',
  getHSGTMarketPage:curl + 'getHSGTMarketPage',
  getHSGTTradingWayPage:curl + 'getHSGTTradingWayPage',
  //私隱政策
  getPrivacyPolicyPage:curl + 'getPrivacyPolicyPage',
  //風險披露
  getRiskDisclaimerPage:curl + 'getRiskDisclaimerPage',
  //个人声明
  getInforCollectPage2:curl + 'getInforCollectPage2',
  getThirdWebRevelation:curl + 'getThirdWebRevelation',
  signHkidrFile:curs + 'signHkidrFile',

  yuyuekaihu: curl + 'getOtherPages/yuyuekaihu',
  zaixiankaihu: curl + 'getOtherPages/zaixiankaihu',
  wangshangjiaoyi: curl + 'getOtherPages/wangshangjiaoyi',
  jiaoxueshipin_cn: curl + 'getOtherPages/jiaoxueshipin_cn',
  jiaoxueshipin_en: curl + 'getOtherPages/jiaoxueshipin_en',
  jiaoxueshipin_web: curl + 'getOtherPages/jiaoxueshipin_web',
  getHolidayList: curls + 'kaihu/getHolidayList',
  newWebYuyue2: curls + 'kaihu/newWebYuyue2',
  
  //银行接口
  getBankWebImg: bank + 'bankWeb/getBankWebImg',
  postUserInformation: bank + 'bankWeb/postUserInformation',
  getBankMenu: bank + 'bankWeb/getBankMenu',
  investmentBanking: bank + 'whatWeDo/investmentBanking',
  assetManagement: bank + 'whatWeDo/assetManagement/get',
  digitalBanking: bank + 'whatWeDo/digitalBanking/get',
  financialLeasing: bank + 'whatWeDo/financialLeasing/get',
  internationalTradeFinance: bank + 'whatWeDo/internationalTradeFinance/get',
  wealthManagement: bank + 'whatWeDo/wealthManagement/get',
  info: bank + 'bankContactUs/info',
  marketHoliday: bank + 'bank/web/NewsAndEvents/marketHoliday',
  announcement: bank + 'bank/web/NewsAndEvents/announcement/get',
  aboutusGetInfo: bank + 'bank/web/aboutus/getInfo',
  privacyDataPolicy: bank + 'bank/web/agreement/privacyDataPolicy/get',
  riskDisclosureStatement: bank + 'bank/web/agreement/riskDisclosureStatement/get',
  generalTermsAndConditionsOfUse: bank + 'bank/web/agreement/generalTermsAndConditionsOfUse/get',
  hyperlinkPolicy: bank + 'bank/web/agreement/hyperlinkPolicy/get',
  securityUsageTips: bank + 'bank/web/agreement/securityUsageTips/get',
  personalDataCollectionStatement: bank + 'bank/web/agreement/personalDataCollectionStatement/get',
  getFlightAddr: bank + 'whatWeDo/financialLeasing/getFlightAddr',
  postFlightsInfo: bank + 'whatWeDo/financialLeasing/postFlightsInfo',
  getGlobal:bank + 'whatWeDo/getGlobal',
  addVideoRecord:bank + 'bankWeb/addVideoRecord',

  // asset
  getHome:asset + 'assetManagement/getHome',
  getFooter:asset + 'assetManagement/getFooter',
  submitCustomerInfo:asset + 'assetManagement/submitCustomerInfo',
  getCareer:asset + 'assetManagement/getCareer',
  getContactUs:asset + 'assetManagement/getContactUs',
  getWhoWeAre:asset + 'assetManagement/getWhoWeAre',
  getWhatWeDo:asset + 'assetManagement/getWhatWeDo',
  getInsights:asset + 'assetManagement/getInsights',
  getNotices:asset + 'assetManagement/getNotices',
  getNoticesPage:asset + 'assetManagement/getNoticesPage',



  
}



// WEBPACK FOOTER //
// ./src/assets/api.js